import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    slideList: () => {
        return HTTP.get('/slide-list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusSlide: (id) => {
        return HTTP.post(`/slide-status-update/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addSlide: (data) => {
        return HTTP.post('/slide-create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editSlide: (id,data) => {
        return HTTP.post(`/slide-update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    slideDetail: (id) => {
        return HTTP.get(`/slide-edit/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteSlide: (id) => {
        return HTTP.post(`/slide-destroy/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}